var GameKeyboardKeys;
(function (GameKeyboardKeys) {
    GameKeyboardKeys["F11"] = "F11";
})(GameKeyboardKeys || (GameKeyboardKeys = {}));

export { GameKeyboardKeys };
